export default function AccessControlContent() {
  return (
    <div>
      <p className="mb-4">
        The Justin Legal API implements an access control system to ensure data
        security and privacy:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          Authenticated law firm operations require either a LawFirm Admin or
          LawFirm Employee Bearer token, or an active API key where the endpoint
          allows API key access.
        </li>
        <li>
          API keys act as an Api Key User for their LawFirm and are validated
          against the request origin before access is granted.
        </li>
        <li>
          Anonymous endpoints are available for intake flows such as creating
          CaseFiles and adding or updating related entities, but service-level
          validation still checks the associated CaseFile and LawFirm rules.
        </li>
        <li>
          Access to entities is generally governed by the owning LawFirm and the
          associated CaseFile permissions.
        </li>
      </ul>
    </div>
  );
}
